import script from "./VacanciesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VacanciesPage.vue?vue&type=script&setup=true&lang=js"

import "./VacanciesPage.vue?vue&type=style&index=0&id=78b9079e&lang=scss"

const __exports__ = script;

export default __exports__